



















import { Component, Vue } from 'vue-property-decorator';
import { Actions } from '@/ts/store/Constants';

@Component({
    name: 'TenantDashboardButtons',
})
export default class TenantDashboardButtons extends Vue {
    constructor() {
        super();
    }

    get unreadNotificationCount(): string | number {
        const count = this.$store.getters['TenantNotifications/getTenantUnreadNotificationsCount'];

        return count > 99 ? '99+' : count;
    }

    get unreadMessageCount(): string | number {
        const count = this.$store.getters['Messages/unreadMessageCount'];

        return count > 99 ? '99+' : count;
    }

    public openNotificationsOverlay() {
        this.$store.dispatch(Actions.SUBMIT_GLOBAL_OVERLAY_CONFIG, {
                title: this.$t('header.notifications', 'Notifications'),
                rightButtonComponent: 'GlobalOverlayCloseButton',
                leftButtonComponent: 'GlobalOverlayBellButton',
                footerComponent: '',
                pageComponent: 'TenantNotifications',
            }).then(() => {
                this.$store.dispatch(Actions.SUBMIT_GLOBAL_OVERLAY_VISIBILITY, true);
            });
    }

    public goToInbox() {
        this.$router.push({ name: 'messages' });
    }
}
